// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import classNames from '@ta/common.classnames';
import { localize } from '@ta/common.i18n';
import type { ViewportCategory } from '@ta/common.state';

import styles from './ForumsListLayout.less';

type ExternalProps = {|
  children: React.Node,
|};

type Props = {|
  ...ExternalProps,
  device: ViewportCategory,
|};

const ForumsListLayout = ({ children, device }: Props) => (
  <div className={styles.layout}>
    {device !== 'MOBILE' && (
      <div className={styles.header}>
        <div className={styles.row}>
          {/* Date */}
          <span className={classNames(styles.cell, styles.date)}>{localize('content_11228')}</span>
          {/* Type */}
          <span className={classNames(styles.cell, styles.type)}>{localize('mw_Type')}</span>
          {/* Forum */}
          <span className={classNames(styles.cell, styles.forum)}>{localize('common_Forum')}</span>
          {/* Topic */}
          <span className={classNames(styles.cell, styles.topic)}>
            {localize('mc_forum_topic_c8c')}
          </span>
        </div>
      </div>
    )}

    <div className={styles.content}>{children}</div>
  </div>
);

export default connect<Props, ExternalProps, _, _, _, _>(redux => ({
  device: redux.meta.device.viewportCategory,
}))(ForumsListLayout);
